import {Box, IconButton, Menu, MenuItem, Tooltip, Typography} from "@mui/material";
import React from "react";
import {IoPersonCircle} from "react-icons/io5";
import {useAuthContext} from "../../contexts/auth-context";

export default function MenuIcon(){
  const [anchorElUser, setAnchorElUser] = React.useState<null | HTMLElement>(null);
  const { logout } = useAuthContext();
  function handleLogout(){
    logout();
  }
  const handleOpenUserMenu = (event: React.MouseEvent<HTMLElement>) => {
    setAnchorElUser(event.currentTarget);
  };

  const handleCloseUserMenu = () => {
    setAnchorElUser(null);
  };
  return (
    <Box>
      <Tooltip title="Opções">
        <IconButton onClick={handleOpenUserMenu} >
          <IoPersonCircle color={"#ffffff"} fontSize={40}/>
        </IconButton>
      </Tooltip>
      <Menu
        sx={{ mt: "45px" }}
        id="menu-appbar"
        anchorEl={anchorElUser}
        disableScrollLock={ true }
        anchorOrigin={{
          vertical: "top",
          horizontal: "right",
        }}
        keepMounted
        transformOrigin={{
          vertical: "top",
          horizontal: "right",
        }}
        open={Boolean(anchorElUser)}
        onClose={handleCloseUserMenu}
      >
          <MenuItem onClick={handleLogout}>
            <Typography textAlign="center">Logout</Typography>
          </MenuItem>
      </Menu>
    </Box>
  );
}
